import { useSelector, useDispatch } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { logout as logoutAction } from 'reducer/authSlice';
import { persistor } from '../store';
import { storeRedirectUrl } from '../utils/sessionUtils';

const useCredentials = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { userData, token, isAuthenticated, loading, error } = useSelector(
    (state) => state.authSlice
  );

  const logout = async () => {
    // Store the current URL before clearing data
    storeRedirectUrl();

    await persistor.purge(); // Clear Redux Persist storage
    dispatch(logoutAction()); // Optional: Dispatch a logout action to reset the state

    navigate('/login');
  };

  return { userData, token, isAuthenticated, loading, error, logout };
};

export default useCredentials;
